// Sentry must load before the rest of the app.
import './instrument'
import React from 'react';
import ReactDOM from 'react-dom';
import * as Sentry from '@sentry/react';
import App from './App';
import './framework/i18n/config'

ReactDOM.render(
  <Sentry.ErrorBoundary fallback={<p>Something went wrong.</p>}>
    <App />
  </Sentry.ErrorBoundary>,
  document.getElementById('root')
);
